"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrCandidateQuerySchema = exports.hrCandidateStageChangeSchema = exports.hrCandidateCreateSchema = exports.hrJobOpeningQuerySchema = exports.hrJobOpeningCreateSchema = exports.hrCandidateStageEnum = exports.hrCandidateSourceEnum = exports.hrJobOpeningStatusEnum = void 0;
const zod_1 = require("zod");
/**
 * HR PHASE 2B — job opening + candidate (recruitment roadmap, follows 2A's
 * job requisition). A job opening is raised against an APPROVED requisition
 * — enforced in `HrJobOpeningService`, not this schema.
 */
exports.hrJobOpeningStatusEnum = zod_1.z.enum(['DRAFT', 'OPEN', 'ON_HOLD', 'CLOSED', 'FILLED']);
exports.hrCandidateSourceEnum = zod_1.z.enum(['REFERRAL', 'JOB_PORTAL', 'WALK_IN', 'AGENCY', 'CAMPUS', 'OTHER']);
exports.hrCandidateStageEnum = zod_1.z.enum([
    'NEW', 'SCREENING', 'SHORTLISTED', 'INTERVIEW', 'ASSESSMENT', 'SELECTED', 'OFFER', 'ACCEPTED', 'REJECTED', 'WITHDRAWN',
]);
exports.hrJobOpeningCreateSchema = zod_1.z.object({
    requisitionId: zod_1.z.string().uuid(),
    title: zod_1.z.string().trim().min(3).max(200),
    openings: zod_1.z.coerce.number().int().positive().max(500).optional(),
    description: zod_1.z.string().trim().max(4000).optional(),
});
exports.hrJobOpeningQuerySchema = zod_1.z.object({
    requisitionId: zod_1.z.string().uuid().optional(),
    status: exports.hrJobOpeningStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
// ── candidates ───────────────────────────────────────────────────────────
exports.hrCandidateCreateSchema = zod_1.z
    .object({
    jobOpeningId: zod_1.z.string().uuid(),
    name: zod_1.z.string().trim().min(2).max(200),
    email: zod_1.z.string().trim().email().max(255).optional(),
    phone: zod_1.z.string().trim().max(20).optional(),
    qualifications: zod_1.z.string().trim().max(2000).optional(),
    experience: zod_1.z.string().trim().max(200).optional(),
    skills: zod_1.z.string().trim().max(2000).optional(),
    source: exports.hrCandidateSourceEnum,
    referredByEmployeeId: zod_1.z.string().uuid().optional(),
})
    .refine((v) => v.source !== 'REFERRAL' || v.referredByEmployeeId, {
    message: 'referredByEmployeeId is required when source is REFERRAL',
    path: ['referredByEmployeeId'],
});
/** Advance is a distinct act from a plain field edit — no PATCH-everything endpoint exists for a candidate. */
exports.hrCandidateStageChangeSchema = zod_1.z
    .object({
    stage: exports.hrCandidateStageEnum,
    reason: zod_1.z.string().trim().max(2000).optional(),
})
    .refine((v) => v.stage !== 'REJECTED' || (v.reason && v.reason.length > 0), {
    message: 'reason is required when rejecting a candidate',
    path: ['reason'],
});
exports.hrCandidateQuerySchema = zod_1.z.object({
    jobOpeningId: zod_1.z.string().uuid().optional(),
    stage: exports.hrCandidateStageEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=hr-job-opening.schema.js.map